import useTicketStatsQuery from '~/hooks/services/servicenow/queries/useTicketStatsQuery'

import { FcDocument } from 'react-icons/fc'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

const AwaitingResponseTicketsTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading } = useTicketStatsQuery()

  return (
    <Tile onMouseDown={() => navigate('/tickets?state=awaiting_response')}>
      <TileHeader loading={isLoading}>
        <TileHeader.Title>{ticketStats?.awaiting_response ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Awaiting Response</TileHeader.Subtitle>
        <TileHeader.Item>
          <FcDocument className="h-10 w-10" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default AwaitingResponseTicketsTile
